"use client";
import { setFocus } from "@noriginmedia/norigin-spatial-navigation";
import { isTvEnv } from "./common.helpers";

export const setFocusOnTv = (focusKey: string) => {
  if (isTvEnv()) {
    setFocus(focusKey);
  }
};
